/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Tracking_Addrevisednda3Inputs */

const en_coinvestments_tracking_addrevisednda3 = /** @type {(inputs: Coinvestments_Tracking_Addrevisednda3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add Revised NDA`)
};

/**
* | output |
* | --- |
* | "Add Revised NDA" |
*
* @param {Coinvestments_Tracking_Addrevisednda3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_tracking_addrevisednda3 = /** @type {((inputs?: Coinvestments_Tracking_Addrevisednda3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Tracking_Addrevisednda3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_tracking_addrevisednda3(inputs)
});
export { coinvestments_tracking_addrevisednda3 as "coInvestments_tracking_addRevisedNda" }